import React from 'react';

import { useTranslation } from '@modernloop/i18n';
import { FormControlLabel, FormHelperText, Radio, RadioGroup, Stack, Typography } from '@mui/material';

import { VideoMeetingLinkScope } from 'src/generated/mloop-graphql';

type Props = {
  value: VideoMeetingLinkScope;
  disabled?: boolean;
  isInterviewersHost?: boolean;
  onChange: (scope: VideoMeetingLinkScope) => void;
};

/** Renders the shared one-link vs. unique-link radio group for meeting-location editors. */
const VideoMeetingLinkScopeRadioGroup = ({ value, disabled = false, isInterviewersHost = false, onChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack spacing={0.5}>
      <Typography variant="subtitle2">{t('hiring-dashboard-common:common.location.videoMeetingLinks')}</Typography>
      <RadioGroup
        data-testid="video-meeting-link-scope-radio-group"
        value={value}
        onChange={(event) => onChange(event.target.value as VideoMeetingLinkScope)}
      >
        <FormControlLabel
          value={VideoMeetingLinkScope.OneLink}
          control={<Radio />}
          label={t('hiring-dashboard-schedule:schedule.communications.sameForAllInterviews')}
          disabled={disabled || isInterviewersHost}
        />
        <FormControlLabel
          value={VideoMeetingLinkScope.UniqueLinkPerInterview}
          control={<Radio />}
          label={t('hiring-dashboard-schedule:schedule.communications.uniqueForEachInterview')}
          disabled={disabled || isInterviewersHost}
        />
      </RadioGroup>
      {isInterviewersHost && (
        <FormHelperText>
          {t('hiring-dashboard-common:common.location.videoMeetingLinksInterviewersHelper')}
        </FormHelperText>
      )}
    </Stack>
  );
};

export default VideoMeetingLinkScopeRadioGroup;
